import { Reveal } from "@/components/common/Reveal";

export function SectionHeading({ eyebrow, title, lines, sub, center = false, light = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      {eyebrow && (
        <Reveal>
          <div className={`eyebrow mb-5 flex items-center gap-3 ${center ? "justify-center" : ""}`}>
            <span className="h-px w-8 bg-[var(--gold)]/60" />
            {eyebrow}
          </div>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`font-serif font-light tracking-tight leading-[1.08] text-3xl sm:text-4xl lg:text-5xl ${light ? "text-[#0b0d13]" : "text-white"}`}>
          {lines ? lines.map((l, i) => <span key={i} className="block">{l}</span>) : title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.1}>
          <p className={`mt-6 text-base sm:text-lg font-light leading-relaxed ${light ? "text-slate-600" : "text-[var(--txt-2)]"}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
